// src/EnterpriseContext.js
import React, { createContext, useContext, useState } from 'react';

const EnterpriseContext = createContext();

export const useEnterprise = () => useContext(EnterpriseContext);

export const EnterpriseProvider = ({ children }) => {
  const [enterprise, setEnterprise] = useState({});

  return (
    <EnterpriseContext.Provider value={{ enterprise, setEnterprise }}>
      {children}
    </EnterpriseContext.Provider>
  );
};
